<div class="text-row" data-automation="card-body-text">
  @for (d of data(); track d) {
    <div class="text-row__item" [style.color]="d?.textColor || 'inherit'">
      <div class="text-row__text-container">
        <h3 class="text-row__label font-regular">{{ d.name }}</h3>
        <div class="text-row__value">
          {{ d.value }}
        </div>
      </div>
    </div>
  }
</div>
